/** Size and edge margin (px) of the docked drone in the bottom-right corner. Shared by the 3D scene and the click target. */
export function dockBox(viewportWidth: number): { size: number; margin: number } {
  return viewportWidth < 768 ? { size: 96, margin: 16 } : { size: 110, margin: 24 };
}
